export default __webpack_public_path__ + "static/media/fbLogo.e76d59fc.png";